function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-disable */
import React from 'react'; // See https://github.com/downshift-js/downshift#getrootprops
// Custom container returns a plain div, without the ARIA markup
// required for a WAI-ARIA 1.1 combobox. See the comments at the
// top of the component file for an explanation of this decision.

var WrapperDiv = function WrapperDiv(_ref) {
  var innerRef = _ref.innerRef,
      rest = _objectWithoutProperties(_ref, ["innerRef"]);

  return /*#__PURE__*/React.createElement("div", _extends({
    ref: innerRef
  }, rest));
};

export default WrapperDiv;